import styled from "styled-components";

const FilterTypeCheckbox = styled.label`
`;

export default FilterTypeCheckbox;